export const KEY_TOKEN = 'TOKEN'
export const KEY_USER = 'USER'
export const USER_ROLE = 'USER_ROLE'
export const USER_PERMISSIONS = 'USER_PERMISSIONS'
export const BYPASS_MFA_TOKEN = 'BYPASS_MFA_TOKEN'
